import React from 'react'
import MicMuted from '../../../assets/icon/class-micmuted.svg'
import MicUnMuted from '../../../assets/icon/class-micunmuted.svg'
const ClassHeader = () => {
  return (
    <div className="flex flex-col md:flex-row w-full justify-between">
      <div className="flex flex-col md:flex-1">
        <div className="text-2xl font-bold leading-[34px] text-white">
          Cryptocurrency Basic Class with Tira Cardhz
        </div>
        <div className="text-base font-normal leading-6 text-white mt-2">Tuesday, May 22, 2023</div>
      </div>
      <div className="flex mt-4 md:mt-0 md:flex-1 justify-end">
        <div className="w-[100px] h-[72px] relative overflow-hidden m-[5px] rounded-lg border-2 border-white">
          <div className="px-2 py-1 text-white bg-[black] absolute left-0 bottom-0 bg-opacity-40  text-xs flex rounded-tr-[5px]">
            <img src={MicMuted} alt="" className="mr-1" />
            <span>You</span>
          </div>
          <img
            className="w-full h-full object-cover"
            src="https://www.shutterstock.com/shutterstock/videos/26198027/thumb/12.jpg?ip=x480"
            alt="Event Image"
          />
        </div>
        <div className="w-[100px] h-[72px] relative overflow-hidden m-[5px] rounded-lg border-2 border-white">
          <div className="px-2 py-1 text-white bg-[black] absolute left-0 bottom-0 bg-opacity-40  text-xs flex rounded-tr-[5px]">
            <img src={MicUnMuted} alt="" className="mr-1" />
            <span>Andrew</span>
          </div>
          <img
            className="w-full h-full object-cover"
            src="https://www.shutterstock.com/shutterstock/videos/26197976/thumb/1.jpg?ip=x480"
            alt="Event Image"
          />
        </div>
      </div>
    </div>
  )
}

export default ClassHeader
